import React from 'react';
import axios from 'axios';
import { Form, Switch, Input, message } from 'antd';
import * as serverconfig from './serverconn';

var CryptoJS = require('crypto-js');

export const REPORT_KEYS = {
  INCOME_STATEMENT: 'income_statement',
  TRIAL_BALANCE_ONBOARDING: 'trial_balance_onboarding',
  TRIAL_BALANCE_DATERANGE: 'trial_balance_daterange',
  BALANCE_SHEET_ONBOARDING: 'balance_sheet_onboarding',
  BALANCE_SHEET_DATERANGE: 'balance_sheet_daterange',
  MEMBER_SUMMARY_PERIOD: 'member_summary_period',
  MEMBER_SUMMARY_DATERANGE: 'member_summary_daterange',
  DAY_LOAN: 'day_loan',
  OUTSTANDING_LOANS: 'outstanding_loans',
  OUTSTANDING_LOANS_PERIOD: 'outstanding_loans_period',
  LOAN_REPAYMENT_STATUS: 'loan_repayment_status',
  LOAN_DEFAULTS: 'loan_defaults',
  LOAN_AGING: 'loan_aging',
  LOAN_DISBURSEMENT: 'loan_disbursement',
  LOAN_REPAYMENTS: 'loan_repayments',
  LOAN_FINES: 'loan_fines',
  TILL_SHEET: 'till_sheet',
  TILL_SHEET_BY_MEMBER: 'till_sheet_by_member',
  LEDGER: 'ledger',
  CASHFLOW: 'cashflow',
  RESERVE: 'reserve',
  MEMBER_AUTO_PAYMENTS: 'member_auto_payments',
  PERIODIC_MEMBER_SUMMARY: 'periodic_member_summary',
  MEMBERS_PER_USER: 'members_per_user',
  SMS_USAGE: 'sms_usage',
  DIVIDENDS_CALCULATOR: 'dividends_calculator',
  PERIODIC_PERFORMANCE_SUMMARY: 'periodic_performance_summary',
  UNBALANCED_JOURNAL_NUMBERS: 'unbalanced_journal_numbers',
  TRANSACTIONS_MISSING_JOURNALS: 'transactions_missing_journals',
  UNMATCHED_JOURNAL_CHART: 'unmatched_journal_chart',
};

export function getSaccoId() {
  if (localStorage.getItem('sacco')) {
    return CryptoJS.AES.decrypt(localStorage.getItem('sacco'), 'my-secret-key@12345').toString(CryptoJS.enc.Utf8);
  }
  return '';
}

export function validateReportEmail(emailReport, receivingEmail) {
  if (!emailReport) {
    return { valid: true };
  }
  if (!receivingEmail || !String(receivingEmail).trim()) {
    return { valid: false, error: 'Please enter a receiving email address.' };
  }
  return { valid: true };
}

export function queueReportEmail(reportKey, params, receivingEmail) {
  const sacco = getSaccoId();
  const formData = new FormData();
  formData.append('report_key', reportKey);
  formData.append('receiving_email', receivingEmail);
  formData.append('sacco', sacco);
  formData.append('params', JSON.stringify({ ...params, sacco }));
  return axios.post(`${serverconfig.backendserverurl}/customqueries/queue_report_email`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  });
}

export function appendInlineEmailFields(formData, emailReport, receivingEmail) {
  formData.append('email_report', JSON.stringify(!!emailReport));
  formData.append('receiving_email', receivingEmail || '');
}

export async function submitReportWithEmail({
  reportKey,
  params,
  emailReport,
  receivingEmail,
  endpoint,
  formData,
  onSuccess,
  setLoading,
  useInlineEmail = false,
}) {
  const validation = validateReportEmail(emailReport, receivingEmail);
  if (!validation.valid) {
    message.error(validation.error);
    return;
  }

  if (setLoading) {
    setLoading(true);
  }

  try {
    if (emailReport && useInlineEmail && endpoint) {
      appendInlineEmailFields(formData, emailReport, receivingEmail);
      const res = await axios.post(endpoint, formData, {
        headers: { 'content-type': 'multipart/form-data' },
      });
      message.info(res.data.message || 'Email processing in background.');
      if (onSuccess) {
        onSuccess(res);
      }
      return;
    }

    if (emailReport) {
      const res = await queueReportEmail(reportKey, params, receivingEmail);
      message.info(res.data.message || 'Email processing in background.');
      return;
    }

    if (!endpoint) {
      message.error('Report endpoint is not configured.');
      return;
    }

    const res = await axios.post(endpoint, formData, {
      headers: { 'content-type': 'multipart/form-data' },
    });
    if (onSuccess) {
      onSuccess(res);
    }
  } catch (error) {
    const serverMessage = error.response && error.response.data && error.response.data.message;
    message.error(serverMessage || 'Failed to process report request.');
  } finally {
    if (setLoading) {
      setLoading(false);
    }
  }
}

export function reportSearchButtonLabel(emailReport) {
  return emailReport ? 'Send Email' : 'Search';
}

export function ReportEmailControls({
  emailReport,
  receivingEmail,
  onEmailReportChange,
  onReceivingEmailChange,
  companyEmail,
}) {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', gap: 12 }}>
      <Form.Item label="Email report?" style={{ marginBottom: 0 }}>
        <Switch
          checked={emailReport}
          onChange={onEmailReportChange}
          checkedChildren="Yes"
          unCheckedChildren="No"
        />
      </Form.Item>
      {emailReport ? (
        <Form.Item label="Receiving email" style={{ marginBottom: 0, minWidth: 260 }}>
          <Input
            value={receivingEmail}
            placeholder={companyEmail || 'name@example.com'}
            onChange={(event) => onReceivingEmailChange(event.target.value)}
          />
        </Form.Item>
      ) : null}
    </div>
  );
}

export function initialReportEmailState(companyEmail = '') {
  return {
    email_report: false,
    receiving_email: companyEmail || '',
  };
}
